import { Loader } from 'components/atoms/Icons'
import React from 'react'

const InfiniteLoader = ({ classes }) => {
  return <Loader classes={'infinite-loader ' + classes} />
}

export default InfiniteLoader
